(function() { window.GUID_b805c0f2_6a37_48a5_b674_98b51af61e7b = { getGuid: function() { return "b805c0f2-6a37-48a5-b674-98b51af61e7b"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Form extends Controls.ControlBase {
            OnDispose() {
                this.$Control.off('invalid-form.validate');
                this.$Control.remove();
            }
            OnBindEvents() {
                /*Sur erreur de validation, ceci est appelé*/
                this.$Control.offon('invalid-form.validate', (e) => {
                    this.Trigger(Form.EventNames.ValidationError, { jqueryEventObject: e, data: e.target });
                });
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            set $Control($control) {
                let oldData = this.$control.data();
                this.$control = $control;
                this.$control.data(oldData);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                let selector = '#' + this.controlId;
                let lastInstance = CS.Controls.GetInstance(CS.Controls.Form, selector, true);
                if (lastInstance && lastInstance.Singletone) {
                    lastInstance.$control = $(selector);
                }
                else {
                    this.$control = $('#' + params[0]); //contient le Id
                }
            }
            Submit(callback = null) {
                let me = this;
                let $form = $(this.$Control);
                //if ($form.data('notajax') == 'True') {
                //    return;
                //}
                $.validator.unobtrusive.parse($form);
                if ($form.valid()) {
                    let form = $form[0];
                    let data = new FormData(form);
                    if (callback || $form.data('nonav') == true) {
                        CS.Ajax.Post(form.action, data, function (response) {
                            if (callback) {
                                callback(response);
                            }
                            if (me.OnSubmitedCallback) {
                                me.OnSubmitedCallback(response);
                            }
                        });
                    }
                    else {
                        CS.Nav.Go(form.action, data, CS.Nav.Source.Post);
                    }
                }
            }
            //Ceci sert pour des forms direct et non pour des popups
            //Il faudra réappeler ceci pour une popup
            static HandleFormValidation() {
                CS.DOM.$body.offon('submit.form', 'form', function (e) {
                    if ($(this).data('notajax') == 'True') {
                        return;
                    }
                    e.preventDefault();
                    let form = this;
                    let $form = $(form);
                    let formInstance = CS.Controls.GetInstance(CS.Controls.Form, $form);
                    if (formInstance != null)
                        formInstance.Submit();
                });
            }
        }
        Controls.Form = Form;
        (function (Form) {
            class Events {
                static ValidationError(param) {
                    Controls.RegisterEvent(Form, EventNames.ValidationError, param);
                }
            }
            Form.Events = Events;
            class EventNames {
            }
            EventNames.ValidationError = "form-validation-error";
            Form.EventNames = EventNames;
        })(Form = Controls.Form || (Controls.Form = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=form.js.map
